import type { FaireProductEntity } from "../../entity_types/product";

export const p_dsbb2tz6uc: FaireProductEntity = {
  token: "p_dsbb2tz6uc",
  type: "product",
  name: "Chocolate Therapy - Flow State Collection - Wholesale",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/540ca69d68e86884bfdf129a5a3ce535f7e82f7cbaa638b0b056eeff3d2e7851.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/95fd48edaea4a6fdc76a9ca1fd234994669c43e56d0a39c1a90620cfbd32532b.jpeg"
  ],
  priceDollars: 9.8,
  description: "SUPERFOOD TEA BLEND \n\nSteep and indulge in this rich and chocolatey ritual designed to hug you back during your menstrual phase—or anytime you need a lift. Mineral-rich raw cacao and magnesium-packed carob work to melt away cramps, with maca and ashwagandha to support your mood and energy. \n\n\nThe Flow State Collection - our first family of functional teas designed to help you feel your best during your cycle, so you can slow down and sync with your body’s natural rhythm.\n\n100% ORGANIC - ADAPTOGENIC - NUTRITIONIST FORMULATED \n\nHow to Enjoy:\n\n * Steep tea in 1 cup of 98° water for 4-6 minutes. \n * Try me with a splash of milk and honey. \n * Tea Latte: Steep tea double strength and top with frothed milk, vanilla and sweetener. \nWhen to Steep:\n\n\n * During your menstrual phase. \n * To ease cramps and aches. \n * To calm your nerves and promote calmness and clarity. \n * To soothe your digestive tract. \nModerate caffeine levels\n\n\n\n",
  tags: [],
  msrpDollars: 15.5,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:44.863Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
